<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <!-- <template #month="params">
        {{ params.params.month ? Number(params.params.month.split('-')[1]) + '月' : "-" }}
      </template> -->
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import Wxts from '../../../components/Wxts.vue';
export default {
  mixins: [tableMixin],
  components: { Wxts },
  data() {
    return {
      baseUrl: 'monther',
      breadcrumb: [
        { name: "财务管理", path: `/finance/monthlyStatistical` },
        { name: "月度统计表", path: `/finance/monthlyStatistical` },
      ],
      wxtsList: [
        {
          name: '净利总额=运费总额-司机工资-押运员工资-车队长工资-出车费用-固定费用-维保费用-附加费用-亏吨金额-利润奖金+运单补差+合同补差'
        },
        // {
        //   name: '司机工资：每月司机工资之和。'
        // },
        // {
        //   name: '押运员工资：每月押运员工资之和。'
        // },
        // {
        //   name: '车队长工资：每月车队长工资之和。'
        // },
        // {
        //   name: '维保费用：每月维保费用之和。'
        // },
        // {
        //   name: '固定费用：每月固定费用之和。'
        // },
        // {
        //   name: '出车费用：每月出车费用之和。'
        // },
        // {
        //   name: '利润总额：每月净利润之和。'
        // },
      ],
      formInline: { year: undefined },
      formCtrl: [
        {
          label: "年份：",
          placeholder: "请选择年份",
          keyName: "year",
          type: 'year',
        },
      ],
      cols: [
        { keyName: "month", label: "月份", minwidth: 100 },
        { keyName: "allfreight", label: "运费总额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "drivermoney", label: "司机工资", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "escortmoney", label: "押运员工资", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "fleetmoney", label: "车队长工资", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "gomoney", label: "出车费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "allfixed", label: "固定费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "allrepair", label: "维保费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "additional_fees", label: "附加费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "eswage", label: "利润奖金", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "compen", label: "运单补差", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "contractmpen", label: "合同补差", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "allprofit", label: "净利总额", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      getTotalProperty: [
        'drivermoney',
        'escortmoney',
        "fleetmoney",
        "allfreight",
        "allrepair",
        "allfixed",
        "gomoney",
        "allprofit",
        "contractmpen",
        'additional_fees',
        'kuitotal',
        'eswage',
        'compen',
      ],
      baseParams: ['year'],
    };
  },
  methods: {},
  mounted() {
    // console.log({ ...this.formInline })
    this.formInline.year = this.DATE_OBJ.y
    // console.log({ ...this.formInline })
    this.getList()
  },
};
</script>

<style lang="less" scoped></style>